const CARTITEMS = "cartItems";
const LANDING_PAGE = "landingPage";
const SCREEN_NAME = "screenName";
const PREVIOUS_SCREEN_NAME = "previousScreenName";

export default {
  CARTITEMS,
  LANDING_PAGE,
  SCREEN_NAME,
  PREVIOUS_SCREEN_NAME,
};
